import axios from 'axios';
import router from '@/router';
import AWN from 'awesome-notifications';
import { removeAuthorization } from '@/services/auth';

axios.defaults.timeout = 60 * 1000; //請求響應時間

axios.defaults.headers.common['Accept'] = 'application/json';

axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

let notifier = new AWN({ position: 'top-right' });

// 響應攔截器
axios.interceptors.response.use(
    response => {
        /*if (response.data.code === 0) {
            return Promise.resolve(response.data); //使用Promise.resolve 正常响应
        } else if (response.data.code === 1401) {
            //服务端定义的响应code码为1401时为未登录
            store.dispatch("setUserInfo", {});
            Message({
                message: "未登录"
            });
            router.push("/login");
            return Promise.reject(response.data); //使用Promise.reject 抛出错误和异常
        } else {
            return Promise.reject(response.data);
        }*/
        //console.log(response);
        if (response.status == 204) {
            return Promise.resolve({ data: [] });
        } else {
            return Promise.resolve(response.data);
        }
    },
    error => {
        if (error && error.response) {
            if (error.response.status === 401) {
                removeAuthorization();
                notifier.alert('登入失敗, 請重新登入！');
                router.push({ path: '/2fa-query/login' });
            } else {
                let res = {};
                res.code = error.response.status;
                //res.msg = throwErr(error.response.status, error.response); //throwErr http狀態碼
                res.msg = error.response.data.message;

                return Promise.reject(res);
            }
        }
        return Promise.reject(error);
    }
);

export default function request(method, url, data) {
    method = method.toLocaleLowerCase(); //封装RESTful API的各种请求方式 以 post get delete为例
    const TOKEN = localStorage.getItem('INX.TOKEN');
    if (TOKEN) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }

    if (method === 'post') {
        return new Promise((resolve, reject) => {
            axios
                .post(url, data)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    } else if (method === 'get') {
        return new Promise((resolve, reject) => {
            axios
                .get(url, { params: data })
                .then(response => {
                    //console.log(response);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    } else if (method === 'delete') {
        return new Promise((resolve, reject) => {
            axios
                .delete(url, { data: data })
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    } else if (method === 'put') {
        return new Promise((resolve, reject) => {
            axios
                .put(url, data)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    } else if (method === 'head') {
        return new Promise((resolve, reject) => {
            axios
                .head(url, data)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}

const throwErr = code => {
    let message = '請求錯誤';
    switch (code) {
        case 400:
            message = '請求錯誤';
            break;
        case 401:
            message = '未授權，請登入';
            break;
        case 403:
            message = '拒絕訪問';
            break;
        case 404:
            message = `找不到資源`;
            break;
        case 408:
            message = '超時';
            break;
        case 500:
            message = '伺服器端錯誤';
            break;
        case 501:
            message = '服務未實現';
            break;
        case 502:
            message = 'Web 伺服器在作為閘道或 Proxy 時收到無效的回應';
            break;
        case 503:
            message = '服務無法使用';
            break;
        case 504:
            message = '閘道逾時';
            break;
        case 505:
            message = '不支援的 HTTP 版本';
            break;
        default:
    }
    return message;
};
